const dealerQueryParameter = 'dealer';

const DealerHelper = {
  // `?dealer=<id>` is the crawlable deep link for JSON-LD;
  // the old `#/dealer/<name>/<id>` links are still read on load.
  getDealerUrl: (dealerId) => {
    const params = new URLSearchParams(window.location.search);
    if (dealerId) {
      params.set(dealerQueryParameter, dealerId);
    } else {
      params.delete(dealerQueryParameter);
    }
    const query = params.toString();
    return `${window.location.pathname}${query ? `?${query}` : ''}`;
  },
  setDealerUrl: (dealerId) => {
    window.history.replaceState(window.history.state, '', DealerHelper.getDealerUrl(dealerId) + window.location.hash);
  },
  getDealerIdFromUrl: () => {
    const dealerId = new URLSearchParams(window.location.search).get(dealerQueryParameter);
    if (dealerId) return dealerId;

    const hash = window.location.hash;
    if (hash.indexOf('/dealer/') === -1) return null;
    const entries = hash.split('/');
    return entries[entries.length - 1];
  },
  getDealersWithinBounds: (map, activeCategory, setDealers, isFirstFetch, setIsFirstFetch) => {
    if (activeCategory !== defaultCategoryValue) {
      const options = {
        method: 'POST',
        body: JSON.stringify({
          productCategoryPreciousId: activeCategory,
          bounds: getBoundsForDealerApi(map),
          isFirstFetch: isFirstFetch,
          zoomLevel: map.getZoom(),
        }),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      };
      fetch('/api/sitecore/dealerlocator/GetDealersWithinBounds', options)
        .then((data) => data.json())
        .then((data) => {
          setDealers(data);

          if (isFirstFetch) {
            fitBounds(map, data);
          }
        });

      setIsFirstFetch(false);
    } else {
      setDealers([]);
      setIsFirstFetch(true);
    }
  },
  getOnlineDealers: (activeCategory, isFirstFetch, setOnlineDealers) => {
    if (activeCategory !== defaultCategoryValue && isFirstFetch) {
      fetch('/api/sitecore/dealerlocator/GetOnlineDealers')
        .then((data) => data.json())
        .then((data) => setOnlineDealers(data));
    }
  },
  getDealer: (dealerId, setIsSingleDealer, setDealers, setSelectedDealer, setUserCoords) => {
    setIsSingleDealer(true);

    const options = {
      method: 'POST',
      body: JSON.stringify({
        dealerId: dealerId,
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    fetch('/api/sitecore/dealerlocator/GetDealer', options)
      .then((data) => data.json())
      .then((data) => {
        setDealers([data]);
        setSelectedDealer(data);
        setUserCoords({
          lat: data.Coordinates.Latitude,
          lng: data.Coordinates.Longitude,
        });
      });
  },
};

const getBoundsForDealerApi = (map) => {
  let bounds = map.getBounds();
  var swLat = bounds.getSouthWest().lat();
  var swLon = bounds.getSouthWest().lng();
  var neLat = bounds.getNorthEast().lat();
  var neLon = bounds.getNorthEast().lng();

  var center = map.getCenter();
  var northEast = { Latitude: neLat, Longitude: neLon };
  var southWest = { Latitude: swLat, Longitude: swLon };

  return {
    NorthEast: northEast,
    SouthWest: southWest,
    Center: {
      Latitude: center.lat(),
      Longitude: center.lng(),
    },
  };
};

const defaultCategoryValue = 'DEFAULT_CATEGORY';

const fitBounds = (map, dealerList) => {
  dealerList = dealerList || dealers;
  let outsideBounds = [];

  dealerList.forEach((dealer) => {
    var coord = new google.maps.LatLng(dealer.Coordinates.Latitude, dealer.Coordinates.Longitude);
    var inbounds = map.getBounds().contains(coord);

    if (!inbounds) outsideBounds.push(dealer);
  });

  if (outsideBounds.length > 0) {
    map.setZoom(map.getZoom() - 1);
    fitBounds(map, dealerList);
  }
};

export default DealerHelper;
